/**
 * @copyright 2019 @ DigiNet
 * @author kimlong
 * @create 2019/01/11 10:37
 * @update 2019/01/11 10:37
 * @file src/components/header/header.js
 */

import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import notify from 'devextreme/ui/notify';
import * as w17F1002Actions from "../../actions/w17F1002-actions";
import * as w17Actions from "../../actions/w17-actions";
import * as mainActions from "../../actions/main-actions";
import EventTracking from "../common/tracking/event";
import { InputGroup, Button as ButtonRB } from 'react-bootstrap';
import InputEmail from "../common/input/input-email";
import PropTypes from 'prop-types';
import Config from '../../config/index';
import {
    TextBox,
    Button,
    ValidationSummary,

} from 'devextreme-react';
import {
    Validator,
    RequiredRule,

} from 'devextreme-react/validator';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import ButtonCustom from "../common/button/button-custom";
import ButtonSendMail from "../common/button/button-sendmail";
import draftToHtml from 'draftjs-to-html';
import { Row, Col } from 'diginet-core-ui/components';
import Select from "react-select";
import { Loading } from "../common/loading/loading";
import { uploadCDN_sync as uploadFileSync, getTokenCDN as getTokenCDNAction } from "../../actions/file-upload-cdn-async";

const cssForm = { margin: '15px 15px 0 15px' };
function getValue(value, defaultValue = "") {
    if (!value) return defaultValue;
    if (Array.isArray(value)) {
        return value.map(v => {
            if (typeof v !== "object") {
                return {
                    label: v,
                    value: v
                }
            }
            return v;
        });
    } else if (typeof value === "object") {
        return [value];
    } else {
        return {
            label: value,
            value: value
        }
    }
}

const newMailScreen = ['W17F2180']; // Các màn hình có cơ cấu gửi mail mới
class W17F1002Page extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            emailTo: '',
            emailCC: [],
            emailBCC: [],
            showCC: false,
            showBCC: false,
            formLoading: false,
            subject: '',
            editorState: EditorState.createEmpty(),
            dataAttachOld: [],
            dataAttach: [],
            contentState: '',
            content: '',
            companyID: this.props.companyID,
            dataCboEmployee: []
        };
        this.timer = null;
        this.tokenCDN = '';
    };

    _setParamFormMail = (data) => {
        let result = null;
        if (!Array.isArray(data) && typeof data === "object") {
            result = {
                emailTo: [],
                emailCC: [],
                emailBCC: [],
                subject: "",
                dataAttachOld: [],
                content: ""
            };
            if (data?.To) {
                const emailTo = data?.To.replace(/,/, ";").split(";");
                result.emailTo = getValue(emailTo.filter(e => !!e), []);
            }
            if (data?.Cc) {
                const emailCC = data?.Cc.replace(/,/, ";").split(";");
                result.emailCC = getValue(emailCC.filter(e => !!e), []);
            }
            if (data?.Bcc) {
                const emailBCC = data?.Bcc.replace(/,/, ";").split(";");
                result.emailBCC = getValue(emailBCC.filter(e => !!e), []);
            }
            if (data?.Subject) result.subject = data?.Subject;
            if (data?.Content) {
                result.content = data?.Content;
                result.editorState = EditorState.createWithContent(
                    ContentState.createFromBlockArray(
                        convertFromHTML(data?.Content)
                    ));
            }
            if (data?.attachments && data?.attachments.length > 0) {
                result.dataAttachOld = data?.attachments;
            }
        }
        this.setState({ ...result });
    };

    loadDefaultMail = () => {
        const { data } = this.props;
        if (data && data.FormID) {
            const params = {
                Language: Config.language || "84",
                ...data,
                FormID: data?.FormID || "",
                KeyID: data?.KeyID || "",
                DivisionID: data?.DivisionID || "",
            };
            this.props.w17F1002Actions.loadContentMail(params, (error, data) => {
                if (error) {
                    Config.popupCore.show('ERROR', error);
                    return false;
                }
                if (data) {
                    this._setParamFormMail(data);
                }
            });
        }
    };

    loadCboEmployee = () => {
        this.setState({ formLoading: true });
        this.props.w17F1002Actions.loadCboEmployee((error, data) => {
            this.setState({ formLoading: false });
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const dataCustom = data.map(item => ({ label: item?.EmployeeName || '', value: item?.Email || '' }));
                this.setState({ dataCboEmployee: [{ label: `<${Config.lang('Tat_ca')}>`, value: 'ALL' }, ...dataCustom] });
            }
        });
    };

    getTokenCDN = async () => {
        const dataCDN = await getTokenCDNAction();
        if (dataCDN?.token) this.tokenCDN = dataCDN.token;
    };

    componentDidMount() {
        const { data } = this.props;
        this.loadDefaultMail();
        if (newMailScreen.includes(data?.FormID)) {
            this.getTokenCDN();
            this.loadCboEmployee();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)) {
            this.loadDefaultMail();
        }
    }

    componentWillUnmount() {
        if (this.timer) clearTimeout(this.timer);
    }

    onTextValueChanged(e) {
        this.setState({ subject: e.event.target.value });
    }

    onEditorStateChange(editorState) {
        this.setState({
            editorState: editorState,
        });
    }

    onHandleChangeTo(value) {
        this.setState({
            emailTo: value
        });
        // console.log("=============onHandleChangeTo============", value);
    }

    onHandleChangeCC(value) {
        this.setState({
            emailCC: value
        });
    }

    onHandleChangeBCC(value) {
        this.setState({
            emailBCC: value
        });
    }

    onEventSave() {
        this.onFormSubmit();
    }

    handleParamSendMai = () => {
        const { FormID = "" } = this.props.data || {};
        const { subject, emailTo, showCC, emailCC, showBCC, emailBCC, content, companyID, dataAttach, dataAttachOld, editorState, dataCboEmployee } = this.state;
        const contentEditor = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        if (Config.isEmpty(emailTo)) {
            Config.popupCore.show("INFO", `EmailTo ${(Config.lang("Khong_duoc_de_trong")).toLowerCase()}`);
            return false;
        }
        if (Config.isEmpty(subject)) {
            Config.popupCore.show("INFO", `${Config.lang("Tieu_de")} ${(Config.lang("Khong_duoc_de_trong")).toLowerCase()}`);
            return false;
        }
        if (Config.isEmpty(content)) {
            Config.popupCore.show("INFO", `${Config.lang("Noi_dung")} ${(Config.lang("Khong_duoc_de_trong")).toLowerCase()}`);
            return false;
        }
        let arrEmailCC = [];
        let arrEmailBCC = [];
        if (showCC && !Config.isEmpty(emailCC)) {
            let emailCCData = emailCC;
            const isCheckAllEmailCC = Config.typeOf(emailCC, 'array') && (emailCC || []).findIndex(item => item?.value === 'ALL') > -1; // Check TẤT CẢ
            if (isCheckAllEmailCC) emailCCData = dataCboEmployee.slice(1, dataCboEmployee.length); // Lấy cả data trừ thằng đầu tiên (TẤT CẢ)
            for (let i = 0; i < emailCCData.length; i++) {
                if (!arrEmailCC.includes(emailCCData[i].value)) arrEmailCC.push(emailCCData[i].value);
            }
        }
        if (showBCC && !Config.isEmpty(emailBCC)) {
            let emailBCCData = emailBCC;
            const isCheckAllEmailCC = Config.typeOf(emailBCC, 'array') && (emailBCC || []).findIndex(item => item?.value === 'ALL') > -1; // Check TẤT CẢ
            if (isCheckAllEmailCC) arrEmailBCC = dataCboEmployee.slice(1, dataCboEmployee.length); // Lấy cả data trừ thằng đầu tiên (TẤT CẢ)
            for (let i = 0; i < emailBCCData.length; i++) {
                if (!arrEmailBCC.includes(emailBCCData[i].value)) arrEmailBCC.push(emailBCCData[i].value);
            }
        }
        let strEmailTo = '';
        if (!Config.isEmpty(emailTo)) {
            for (let i = 0; i < emailTo.length; i++) {
                if (Config.typeOf(newMailScreen.includes(FormID))) {
                    if (i === 0) strEmailTo = [];
                    strEmailTo.push(emailTo[i].value);
                } else {
                    if (strEmailTo !== '') strEmailTo += ",";
                    strEmailTo += emailTo[i].value;
                }
            }
        }
        let paramGeneral = {
            'subject': subject,
            'content': contentEditor,
            'attachments': dataAttach,
        };

        let paramSendMailText = {
            'FormID': FormID,
            'emailTo': strEmailTo,
            'emailCC': JSON.stringify(arrEmailCC),
            'emailBCC': JSON.stringify(arrEmailBCC),
            'attachmentsURL': JSON.stringify(dataAttachOld),
            ...paramGeneral
        };
        let arrEmailTo = emailTo;
        const isCheckAllEmailTo = (emailTo || []).findIndex(item => item?.value === 'ALL') > -1; // Check TẤT CẢ
        if (isCheckAllEmailTo) arrEmailTo = dataCboEmployee.slice(1, dataCboEmployee.length); // Bỏ phần tử đầu (TẤT CẢ)
        arrEmailTo = (arrEmailTo || []).map(item => item?.value || '');
        const paramSendMailDD = {
            to: [...new Set(arrEmailTo)], // Bỏ những mail trùng lập
            cc: arrEmailCC,
            bcc: arrEmailBCC,
            key01: '',
            key02: '',
            key03: '',
            params: JSON.stringify([]),
            ...paramGeneral
        };

        const paramSave = {
            'MailTO': strEmailTo,
            'MailCC': arrEmailCC,
            'MailBCC': arrEmailBCC,
            'MailSubject': subject,
            'MailSender': 'ServerMail',
            'MailContent': contentEditor,
            'CompanyID': companyID
        };
        return { paramSendMailText, paramSendMailDD, paramSave };
    };

    _uploadFile = (files) => {
        return uploadFileSync(files, 'multiple', this.tokenCDN);
    };

    _getAttachments = (file) => {
        const dataFile = file?.data?.paths || [];
        const listAttachments = Config.helpers.getFileInfomations(dataFile);
        const { dataAttachOld } = this.state;
        let arrAttachment = [];
        listAttachments.forEach((att) => {
            arrAttachment.push({
                path: att.url ? att.url : "",
                filename: att.fileName ? att.fileName : "",
            });
        });
        if (dataAttachOld && dataAttachOld.length > 0) {
            arrAttachment = dataAttachOld.concat(arrAttachment);
        }
        return arrAttachment;
    };

    onFormSubmit = async () => {
        const { data, onHide } = this.props;
        let dataParam = this.handleParamSendMai();
        if (!dataParam) return;
        this.setState({ formLoading: true });
        let { paramSendMailText, paramSendMailDD, paramSave } = dataParam || {};
        if (newMailScreen.includes(data?.FormID)) { // Dạng DropDown
            const dataUploaded = !Config.isEmpty(this.state.dataAttach) ? await this._uploadFile(this.state.dataAttach) : {};
            const attachmentsURL = this._getAttachments(dataUploaded);
            paramSendMailDD.attachmentsURL = attachmentsURL;
            this.props.w17F1002Actions.sendMailV2(paramSendMailDD, (error, data) => {
                this.setState({ formLoading: false });
                if (error) {
                    Config.popupCore.show('ERROR', error);
                    return;
                } else if (data) {
                    Config.notify.show('success', Config.lang('Gui_thanh_cong'), 2000);
                    if (onHide) this.timer = setTimeout(() => onHide(), 300);
                }
            });
        } else { // Dạng TextInput 
            this.props.w17F1002Actions.sendMail(paramSendMailText, (error, data) => {
                let message = '';
                let statusEmail = 'SUCCESS';
                if (error) {
                    this.setState({ formLoading: false });
                    statusEmail = 'FAIL';
                    message = error.message || Config.lang("Loi_chua_xac_dinh");
                    Config.popupCore.show('ERROR', error);
                    return;
                }
                let arrURL = '';
                if (data)
                    arrURL = data.urls;
                else {
                    Config.popupCore.show('INFO', Config.lang("Co_loi_trong_qua_trinh_gui_Mail"));
                }
                paramSave.StatusEmail = statusEmail;
                paramSave.ErrorDescription = message;
                this.props.w17F1002Actions.saveMail(paramSave, (err, res) => {
                    this.setState({ formLoading: false });
                    if (err) {
                        Config.popupCore.show('ERROR', err);
                        return;
                    }
                    if (res) {
                        if (res.KeyID !== '') {
                            if (arrURL.length > 0 && arrURL.length === this.state.dataAttach.length) {
                                this.saveFileAttachment(res.KeyID, arrURL);
                            }
                            if (arrURL !== '') {
                                notify(Config.lang("Gui_thanh_cong"), "success", 2000);
                                if (onHide) this.timer = setTimeout(() => onHide(), 300);
                            }
                        } else {
                            Config.popupCore.show('INFO', Config.lang("Co_loi_trong_qua_trinh_luu_File"));
                        }
                    }
                });
            });
        }
    }

    saveFileAttachment(keyID, arrURL) {
        const file = this.state.dataAttach;
        for (let i = 0; i < file.length; i++) {
            const tableName = 'D17T5000';
            const fileName = file[i].name;
            const url = arrURL[i].path;
            const fileSize = file[i].size;
            const fileExp = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();

            let param = {
                'KeyID': keyID,
                'AttachmentID': "",
                'DescriptionU': "Tài liệu đính kèm khi gửi mail",
                'NotesU': "Tài liệu đính kèm khi gửi mail",
                'URL': url,
                'FileName': fileName,
                'FileSize': fileSize,
                'FileExp': fileExp,
                'TableName': tableName
            };
            // console.log("============onFormSubmit=============", param);
            this.props.w17Actions.addW17F0001(param, (error, res2) => {
                if (error) {
                    Config.popupCore.show('ERROR', error);
                    return false;
                }
            });

        }
    }

    showHideCC() {
        this.setState({ showCC: !this.state.showCC });
    }

    showHideBCC() {
        this.setState({ showBCC: !this.state.showBCC });
    }

    checkFileType(filename) {
        const extension = filename.substr(filename.lastIndexOf('.')).toLowerCase();
        const allowedExtensions = ['.txt', '.jpg', '.png', '.xls', '.xlsx', '.doc', '.docx', '.pdf'];
        if (extension.length > 0) {
            if (allowedExtensions.indexOf(extension) === -1) {
                return false;
            }
        }
        return true;
    }

    upLoadAttach() {
        const x = document.getElementById("attachments");
        const arrFile = x.files;
        const sizeLimit = 50000000;
        const that = this;
        let dataAttach = [...that.state.dataAttach];
        for (let i = 0; i < arrFile.length; i++) {

            if ((arrFile[i].size / 1024) > Number(sizeLimit)) {
                Config.popupCore.show("INFO", Config.lang("Dung_luong_File_khong_duoc_lon_hon") + " " + sizeLimit + ' KB');
            } else if (this.checkFileType(arrFile[i].name) === false) {
                Config.popupCore.show("INFO", Config.lang("Dinh_dang_file_khong_hop_le"));
            }
            else { //truong hop hop le
                let file = arrFile[i];
                // console.log("===========upLoadAttach=============", file);


                // file.uploading = true
                dataAttach.push(file);
                that.setState({
                    dataAttach: dataAttach,
                })
            }
        }
    }

    deleteAttach(file, isOld) {
        const { dataAttach, dataAttachOld } = this.state;
        if (isOld) {
            this.setState({ dataAttachOld: dataAttachOld.filter((value) => value.path !== file.path) });
        } else {
            this.setState({ dataAttach: dataAttach.filter((value) => value.name !== file.name) });
        }
    }

    onContentStateChange(contentState) {
        let str = "";
        for (let block of contentState.blocks) {
            str += block?.text || "";
        }
        this.setState({
            contentState: contentState,
            content: str.trim()
        });
    };

    renderSendMailBoard = (name) => {
        let result = null;
        let value = '';
        const { data } = this.props;
        const { emailTo, emailCC, emailBCC, dataCboEmployee } = this.state;
        let dataSource = dataCboEmployee;
        switch (name) {
            case "emailTo":
                value = emailTo;
                break;
            case "emailCC":
                value = emailCC;
                break;
            case "emailBCC":
                value = emailBCC;
                break;
            default:
                break;
        }
        if (newMailScreen.includes(data?.FormID)) { // Dropdown
            if (Config.isEmpty(value)) value = [];
            const isCheckAll = (value || []).findIndex(item => item.value === 'ALL') > -1;
            if (isCheckAll) dataSource = [dataCboEmployee?.[0]];
            result = <Select
                isMulti
                value={value}
                options={dataSource}
                placeholder={''}
                displayExpr={'label'}
                valueExpr={'value'}
                onChange={(e) => {
                    const val = (e || []).some(item => item.value === 'ALL') ? [dataCboEmployee[0]] : e;
                    this.setState({ [name]: val });
                }}
            />
        } else {
            result = <InputEmail
                placeholder={''}
                value={value}
                handleChange={(e) => {
                    this.setState({
                        [name]: e
                    });
                }}>
            </InputEmail>
        }
        return result;
    };

    render() {
        const { emailTo, showCC, emailCC, emailBCC, showBCC, subject, editorState, content, dataAttach, dataAttachOld, isUploaded, fileName, isSubmit, formLoading } = this.state;

        return (
            <div style={cssForm}>
                {formLoading && <Loading />}
                {Config && Config.profile && <EventTracking category={"TRACKING_USER"} action={"W17F1002"} label={Config.profile.UserID} />}
                <Row>
                    <Col sm={12}>
                        <InputGroup>
                            <InputGroup.Button>
                                <ButtonRB tabIndex="-1" className="btn-email  btn-group-email">To</ButtonRB>
                            </InputGroup.Button>
                            {this.renderSendMailBoard('emailTo')}
                            <InputGroup.Button>
                                <ButtonRB tabIndex="-1" className="btn-email  btn-group-email" onClick={() => {
                                    this.showHideCC()
                                }}>Cc</ButtonRB>
                                <ButtonRB tabIndex="-1" className="btn-email  btn-group-email" onClick={() => {
                                    this.showHideBCC()
                                }}>Bcc</ButtonRB>
                            </InputGroup.Button>
                        </InputGroup>
                        <TextBox
                            value={emailTo.length > 0 ? 'n' : ''}
                            className="input-devextreme hide">
                            <Validator>
                                <RequiredRule message={Config.lang("Ban_chua_nhap_Email_nguoi_nhan")} />
                            </Validator>
                        </TextBox>
                    </Col>
                    {showCC &&
                        <Col sm={12}>
                            <InputGroup>
                                <InputGroup.Button>
                                    <ButtonRB tabIndex="-1" className="btn-email  btn-group-email ">Cc</ButtonRB>
                                </InputGroup.Button>
                                {this.renderSendMailBoard('emailCC')}
                            </InputGroup>
                            <TextBox
                                value={emailCC.length > 0 ? 'n' : ''}
                                className="input-devextreme hide">
                                <Validator>
                                    <RequiredRule message={Config.lang("Ban_chua_nhap_Email_Cc")} />
                                </Validator>
                            </TextBox>
                        </Col>
                    }
                    {showBCC &&
                        <Col sm={12}>
                            <InputGroup>
                                <InputGroup.Button>
                                    <ButtonRB tabIndex="-1" className="btn-email  btn-group-email">Bcc</ButtonRB>
                                </InputGroup.Button>
                                {this.renderSendMailBoard('emailBCC')}
                            </InputGroup>
                            <TextBox
                                value={emailBCC.length > 0 ? 'n' : ''}
                                className="input-devextreme hide">
                                <Validator>
                                    <RequiredRule message={Config.lang("Ban_chua_nhap_Email_Bcc")} />
                                </Validator>
                            </TextBox>
                        </Col>
                    }
                    <Col sm={12}>
                        <TextBox name={"Subject"}
                            value={subject}
                            onChange={(e) => this.onTextValueChanged(e)}
                            className="input-devextreme"
                        >
                        </TextBox>
                        <TextBox
                            value={subject}
                            className="input-devextreme hide">
                            <Validator>
                                <RequiredRule message={Config.lang("Ban_chua_nhap_chu_de_cua_Email")} />
                            </Validator>
                        </TextBox>
                    </Col>
                    <Col sm={12}>
                        <Editor
                            style={{ height: '500px' }}
                            editorState={editorState}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="editorClassName"
                            onEditorStateChange={(e) => {
                                this.onEditorStateChange(e)
                            }}
                            onContentStateChange={(e) => {
                                this.onContentStateChange(e)
                            }}
                        />
                        <TextBox
                            value={content}
                            className="input-devextreme hide">
                            <Validator>
                                <RequiredRule message={Config.lang("Ban_chua_nhap_noi_dung_Email")} />
                            </Validator>
                        </TextBox>
                    </Col>
                    <Col sm={12}>
                        {dataAttachOld.map((value, index) => {
                            return (
                                <label className={'mgr2x item-attachtment'} key={index}>{value?.filename || ''} <i
                                    className="mgl2x fal fa-times text-red " onClick={() => {
                                        this.deleteAttach(value, true)
                                    }} /> </label>);
                        })}
                        {dataAttach.map((value, index) => {
                            return (
                                <label className={'mgr2x item-attachtment'} key={index}>{value?.name || ''} <i
                                    className="mgl2x fal fa-times text-red " onClick={() => {
                                        this.deleteAttach(value)
                                    }} /> </label>);
                        })}
                    </Col>
                    <Col sm={7}>
                        <ValidationSummary id={'summary'}></ValidationSummary>
                    </Col>
                    <Col sm={5} className={"jus-end"}>
                        <ButtonCustom icon={'fas fa-paperclip'} isAwesome={true} className={'mgr1x'}
                            color={'text-green'} name={Config.lang("Dinh_kem")}
                            onClick={() => {
                                document.getElementById('attachments').click();
                            }}
                        />
                        <input id={'attachments'} type="file" name="attachments[]"
                            className="media_upload_input hide" multiple
                            onChange={() => {
                                this.upLoadAttach()
                            }} />
                        <ButtonSendMail
                            disabled={isUploaded === true || fileName === '' || isSubmit === true}
                            onClick={() => this.onEventSave()} className={"mgr1x"}
                            name={Config.lang("Gui_mail")} />
                        {/*<ButtonClose name={Config.lang("Dong1")} onClick={() => {*/}
                        {/*this.props.onHide()*/}
                        {/*}}></ButtonClose>*/}
                        <Button id="btnSubmit" onClick={(e) => this.onFormSubmit(e)} useSubmitBehavior={true} className="hide" />
                    </Col>
                </Row>
            </div>
        )
    }
}

W17F1002Page.propTypes = {
    onHide: PropTypes.func,
    companyID: PropTypes.string,
    /**
     * {
            FormID: "",
            KeyID: ",
            DivisionID: ""
        }
     */
    data: PropTypes.object,
};

export default connect(state => ({
    sendMail: state.w17F1002.sendMail,
    saveMail: state.w17F1002.saveMail,
    addW17F0001: state.w17.addW17F0001,
}),
    (dispatch) => ({
        w17F1002Actions: bindActionCreators(w17F1002Actions, dispatch),
        w17Actions: bindActionCreators(w17Actions, dispatch),
        mainActions: bindActionCreators(mainActions, dispatch),
    })
)(W17F1002Page);
